import Vue from 'src/views/base'
import { Component } from 'vue-property-decorator'
import template from './protocol.vue'
import ContentLayout from 'src/views/components/content-layout'
import newHeader from 'src/views/components/new-header'

/**
 * 用户服务协议页面
 *
 * @export
 * @class Protocol
 * @extends {Vue}
 */
@Component({
    name: 'protocol',
    mixins: [ template ],
    components: {
        ContentLayout,
        newHeader
    }
})
export default class Protocol extends Vue {
    
}



// WEBPACK FOOTER //
// ./src/views/page/main/protocol/index.js